import axios from 'axios';

import constants from '../constants';

const ontraqBaseAPIURL = `${constants.ONTRAQ_API_URL}`;

export interface SetupUserData {
  customerNumber: string;
  userId: string;
  password: string;
  phone: string;
  emailOption: boolean;
  textOption: boolean;
}

export const getUserDetails = async (customerNumber: string) => {
  return await axios.get(`${ontraqBaseAPIURL}/api2/${customerNumber}/users/details?scope=withNotificationGroups`).then((response) => response.data);
}

/**
 *
 * @returns {string} - a timezone in a short code format E.G. 'PST'
 */
export const getTimezone = (customerNumber: string) => {
  return axios
    .get<{ timezone: string }>(`${ontraqBaseAPIURL}/api2/${customerNumber}/users/timezone`)
    .then((response) => response.data.timezone);
}

/**
 * Sets up a user with the provided user data
 * @param user - The user setup data
 * @returns Promise with the setup response
 */
export const setupUser = (user: SetupUserData) =>
  axios.post(`${ontraqBaseAPIURL}/api2/users/setup-user`, {
    ...user
  });

/**
 * Verifies a user with the provided token
 * @param token - The verification token
 * @returns Promise with the verification response
 */
export const verifyUser = (token: string) =>
  axios.post(`${ontraqBaseAPIURL}/api2/users/verify-user`, {
    userId: token
  }).then((response) => response.data);